import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcessKxBuUserInfoExportStatus: 'idle',
    startProcessKxBuUserInfoExportError: undefined as any,
    loadUserParamsProcessKxBuUserInfoExportStatus: 'idle',
    loadUserParamsProcessKxBuUserInfoExportError: undefined as any,

    processKxBuUserInfoExportList: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcessKxBuUserInfoExport = createAsyncThunk('processKxBuUserInfoExportSlice/startProcessKxBuUserInfoExport', async ({ processKxBuUserInfoExport }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcessKxBuUserInfoExport/`,
        prepareData(processKxBuUserInfoExport),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcessKxBuUserInfoExportStatus } = getState().processKxBuUserInfoExportSlice
        return startProcessKxBuUserInfoExportStatus !== 'pending'
    }
})

export const loadUserParamsProcessKxBuUserInfoExport = createAsyncThunk('processKxBuUserInfoExportSlice/loadUserParamsProcessKxBuUserInfoExport', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcessKxBuUserInfoExport/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcessKxBuUserInfoExportStatus } = getState().processKxBuUserInfoExportSlice
        return loadUserParamsProcessKxBuUserInfoExportStatus !== 'pending'
    }
})

const ProcessKxBuUserInfoExportSlice = createSlice({
    name: 'processKxBuUserInfoExportSlice',
    initialState,
    reducers: {
        resetstartProcessKxBuUserInfoExport: (state) => {
            state.job = undefined
            state.startProcessKxBuUserInfoExportError = undefined
        },
        resetstartProcessKxBuUserInfoExportError: (state) => {
            state.startProcessKxBuUserInfoExportError = undefined
        },
        resetloadUserParamsProcessKxBuUserInfoExport: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcessKxBuUserInfoExportError = undefined
        },
        resetloadUserParamsProcessKxBuUserInfoExportError: (state) => {
            state.loadUserParamsProcessKxBuUserInfoExportError = undefined
        },
        removeFromProcessKxBuUserInfoExportListById: (state, action) => {
            state.processKxBuUserInfoExportList = state.processKxBuUserInfoExportList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcessKxBuUserInfoExportListByIds: (state, action) => {
            state.processKxBuUserInfoExportList = state.processKxBuUserInfoExportList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.processKxBuUserInfoExportList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcessKxBuUserInfoExportStatus = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.processKxBuUserInfoExportList = []
            state.startProcessKxBuUserInfoExportStatus = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcessKxBuUserInfoExport.pending, (state) => {
            state.startProcessKxBuUserInfoExportStatus = 'pending'
            state.startProcessKxBuUserInfoExportError = undefined
        })
        builder.addCase(startProcessKxBuUserInfoExport.fulfilled, (state, action) => {
            state.startProcessKxBuUserInfoExportStatus = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcessKxBuUserInfoExport.rejected, (state, action) => {
            state.startProcessKxBuUserInfoExportStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcessKxBuUserInfoExportError = action.error.message
            } else {
                state.startProcessKxBuUserInfoExportError = action.payload
            }
        })

        builder.addCase(loadUserParamsProcessKxBuUserInfoExport.pending, (state) => {
            state.loadUserParamsProcessKxBuUserInfoExportStatus = 'pending'
            state.loadUserParamsProcessKxBuUserInfoExportError = undefined
        })
        builder.addCase(loadUserParamsProcessKxBuUserInfoExport.fulfilled, (state, action) => {
            state.loadUserParamsProcessKxBuUserInfoExportStatus = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcessKxBuUserInfoExport.rejected, (state, action) => {
            state.loadUserParamsProcessKxBuUserInfoExportStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcessKxBuUserInfoExportError = action.error.message
            } else {
                state.loadUserParamsProcessKxBuUserInfoExportError = action.payload
            }
        })

    }
})

export const {
    resetstartProcessKxBuUserInfoExport,
    resetstartProcessKxBuUserInfoExportError,
    resetloadUserParamsProcessKxBuUserInfoExport,
    resetloadUserParamsProcessKxBuUserInfoExportError,
    removeFromProcessKxBuUserInfoExportListById,
    removeFromProcessKxBuUserInfoExportListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = ProcessKxBuUserInfoExportSlice.actions
export default ProcessKxBuUserInfoExportSlice.reducer
